import contractorInvoice from "./contractorInvoice.component";
import contractorInvoiceUrls from "./contractorInvoice.urls";
import ContractorInvoiceTransforms from "./contractorInvoice.transforms";

const contractorInvoiceModule = angular
  .module("app.components.contractorInvoice", [])
  .component("contractorInvoicePage", contractorInvoice)
  .service("ContractorInvoiceTransforms", ContractorInvoiceTransforms)
  .config(contractorInvoiceUrls);

export default contractorInvoiceModule;



// WEBPACK FOOTER //
// ./src/pages/contractorInvoice/contractorInvoice.module.js